import UnitQuiz from '../Homework/UnitQuiz/component';
import Privileges from 'domain/Privileges';
import { PrivilegeChecker } from 'omni-common-ui';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';

export default ({ getState }) => ({
  path: 'unit-review',
  component: UnitQuiz,
  canAccess: ({ params }) =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.Homework.View) &&
      TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.UnitReview),
  tab: {
    label: 'Unit Review',
    order: 5,
    isVisible: (params) =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.Homework.View) &&
      TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.UnitReview),
  },
  breadcrumbLabels: () =>
    [{
      label: 'Unit Review',
      clickable: false,
    }],
});



// WEBPACK FOOTER //
// ./containers/Group/UnitReview/routes.js